import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { LOVProcessedEntityTypeExtension } from 'app/models/extensions/lov-processed-entity-type-extension.model';
import { ProcessedEntity } from 'app/models/processed-entity.model';
import { MRMValidators } from '@mrm/core';

export class LOVProcessedEntityType extends LOVProcessedEntityTypeExtension {
  processedEntityTypeDBID: number = 0;
  englishDescription: string = null;
  frenchDescription: string = null;
  orgTypeCode?: number = null;
  luisOrganizationTypeDBID?: number = null;
  isActive?: boolean = null;
  orderNumber: number = 0;
  createdDT: Date = new Date();
  createdBy: string = null;
  modifiedDT: Date = new Date();
  modifiedBy: string = null;
  rowVersion: number = 0;
  processedEntities: ProcessedEntity[] = [];

  static getForm(disableAll: boolean = false, includeNav: string[] = []): FormGroup {
    const form = new FormGroup({
      processedEntityTypeDBID: new FormControl({ value: 0, disabled: disableAll }),
      englishDescription: new FormControl({ value: null, disabled: disableAll }, [Validators.required, Validators.maxLength(255)]),
      frenchDescription: new FormControl({ value: null, disabled: disableAll }, [Validators.required, Validators.maxLength(255)]),
      orgTypeCode: new FormControl({ value: null, disabled: disableAll }),
      luisOrganizationTypeDBID: new FormControl({ value: null, disabled: disableAll }),
      isActive: new FormControl({ value: null, disabled: disableAll }),
      orderNumber: new FormControl({ value: 0, disabled: disableAll }, [Validators.required, MRMValidators.number]),
      createdDT: new FormControl({ value: new Date(), disabled: disableAll }, [Validators.required]),
      createdBy: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(50)]),
      modifiedDT: new FormControl({ value: new Date(), disabled: disableAll }, [Validators.required]),
      modifiedBy: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(50)]),
      rowVersion: new FormControl({ value: 0, disabled: disableAll }),
      processedEntities: new FormArray([])
    });


    return form;
  }
}